import React from 'react';
import { Button } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import usePlannerSettings from "../../../contexts/PlannerContext";
import { useTranslation } from "react-i18next";

export default function ToggleComplementiButton() {
    const theme = useTheme();
    const { complementiAttivi, setComplementiAttivi } = usePlannerSettings();
    const { t, i18n } = useTranslation();

    const handleToggle = () => setComplementiAttivi(!complementiAttivi);

    return (
        <Button
            size="large"
            style={{height: "initial"}}
            // variant={complementiAttivi ? "contained" : "outlined"}
            variant="contained"
            sx={{
                // bgcolor: complementiAttivi ? theme.palette.primary.main : "transparent",
                bgcolor: theme.palette.primary.main,
                fontSize: '1.1rem',
                // color: complementiAttivi ? "#fff" : theme.palette.primary.main,
                color: "#fff",
                borderColor: theme.palette.primary.main,
                textTransform: 'none',
                width: '100%',
                "&:hover": {
                    // bgcolor: complementiAttivi ? theme.palette.primary.dark : theme.palette.action.hover,
                    bgcolor: theme.palette.primary.dark,
                    borderColor: theme.palette.primary.main,
                },
            }}
            onClick={handleToggle}
        >
            {complementiAttivi ? t("settings.drawer.switch.back_to_blocks") : t("settings.drawer.switch.go_to_furnishing")}
        </Button>
    );
}
